import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import TopicDetail from '../views/TopicDetail.vue'  // 导入详情页组件
import MollyProductDetail from '../views/MollyProductDetail.vue'  // 导入产品详情页组件
import ContactPage from '../views/ContactPage.vue'  // 导入联系我们页组件
import ApplicationForm from '../views/ApplicationForm.vue'  // 导入申请表单页组件
import FAQPage from '../views/FAQPage.vue'  // 导入常见问题页面组件

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/topic-detail',
    name: 'TopicDetail',
    component: TopicDetail
  },
  {
    path: '/product-detail',
    name: 'MollyProductDetail',
    component: MollyProductDetail
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/application-form',
    name: 'ApplicationForm',
    component: ApplicationForm
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQPage
  }
  // 其他路由配置...
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
